import { TCompanyBankList } from '../../type/regist';
import actionTypes from './actionType';

export const fetch = (response: TCompanyBankList) => ({ type: actionTypes.FETCH, response });

export type Actions =
| ReturnType<typeof fetch>
